<template>
  <div>
    <div class="list-title">
      <h3>Proveedores</h3>
    </div>

    <div class="search-bar">
      <v-container fluid class="pa-0">
        <v-layout row wrap>
          <v-flex xs12 md3>
            <v-text-field class="lance" v-model="search.code" label="Vendor Number"></v-text-field>
          </v-flex>
          <v-flex xs12 md3>
            <v-text-field class="lance" v-model="search.businessName" label="Razón Social"></v-text-field>
          </v-flex>
          <v-flex xs12 md3>
            <v-text-field class="lance" v-model="search.rfc" label="RFC / Tax ID"></v-text-field>
          </v-flex>
          <v-flex xs12 md3>
            <v-switch class="lance" v-model="search.active" color="primary" label="Activo"></v-switch>
          </v-flex>
        </v-layout>
      </v-container>
    </div>
      
    <v-data-table
      class="table-catalog elevation-5"
      :headers="headers"
      :items="list"
      :loading="loading">
      <v-progress-linear slot="progress" color="primary" indeterminate></v-progress-linear>
      <template slot="items" slot-scope="props" @click="goTo('Suppliersform/' + props.item.id)">
        <tr v-bind:class="{ itemToDelete: props.item.id === itemToDelete }">
          <td class="text-xs-left">{{ props.item.code }}</td>
          <td class="text-xs-left"><pre class="pre-inherit">{{ props.item.businessName }}</pre></td>
          <td class="text-xs-left">{{ props.item.rfc || props.item.legalCode}}</td>
          <td class="text-xs-left">{{ getSupplierType(props.item.supplierTypeId) }}</td>
          <td class="text-xs-left">{{ formatDate(props.item.createdAt, true) }}</td>
          <td>
            <v-tooltip
              bottom
              v-if="credentials.InvoiceTemplateUpdate"
              :disabled="props.item.supplierTypeId != 1"
            >
              <v-btn fab small color="primary"
                slot="activator"
                @click.stop="goTo('InvoiceTemplateForm/' + props.item.code)"
                :disabled="props.item.supplierTypeId == 1">
                <img src="@/assets/icon-estatus-de-factura.svg" width="15px" alt="">
              </v-btn>
              <span>Los proveedores nacionales no necesitan template</span>
            </v-tooltip>
            <v-tooltip
              bottom
              v-if="credentials.InvoiceTemplateRead"
              :disabled="props.item.supplierTypeId != 1"
            >
              <v-btn fab small color="primary"
                slot="activator"
                @click.stop="goTo('InvoiceTemplateDetail/' + props.item.code)"
                :disabled="props.item.supplierTypeId == 1">
                <v-icon>visibility</v-icon>
              </v-btn>
              <span>Los proveedores nacionales no necesitan template</span>
            </v-tooltip>
          </td>
        </tr>
      </template>
      <template slot="no-data">
        No hay registros para sus parámetros de búsqueda. Favor de intentar otra búsqueda o crear uno nuevo.
      </template>
    </v-data-table>
  </div>
</template>


<script>
  import { events, printList } from '../main';
  import _ from 'underscore';
  import moment from 'moment-timezone';

  export default {
    components: { },
    data () {
      return {
        credentials: JSON.parse(localStorage.getItem('userCredentials')),
        deleteDialog: false,
        headers: [
          { text: 'Vendor Number', value: 'code' },
          { text: 'Razón Social', value: 'businessName' },
          { text: 'RFC / Tax ID', value: 'rfc' },
          { text: 'Tipo Proveedor', value: 'supplierTypeId' },
          { text: 'Fecha Registro', value: 'createdAt' },
          { text: '', value: 'actions', sortable: false, width: 0}
        ],
        itemToDelete: '',
        list: [],
        loading: true,
        search: {
          active: true
        },
        showFilters: false,
        source: [],
        supplierTypes: []
      }
    },
    methods: {
      clean(field) {
        this.search[field] = null;
        this.$refs[`${field}Menu`].save(this.search[field]);
      },
      formatDate(date, withUtc=false) {
        if(date) {
            let mdate = moment(date);
            if (withUtc) mdate = mdate.utc();
            const ndate = mdate.locale("es-mx").format("DD/MMM/YYYY");
            const mes = ndate.split("/")[1];
            const nmes = mes.charAt(0).toUpperCase() + mes.slice(1, -1);
            return ndate.replace(mes, nmes);
        }
        return '';
      },
      getList: function() {
        this.$http.get('Suppliers')
          .then(response => {
            const list = response.body;
            this.list = list;
            this.source = list;
            this.loading = false;
          }, error => {
            this.snackbar('Hubo un problema al obtener la lista');
            console.error(error);
          });
      },
      getSupplierType(value) {
        const supplierType = this.supplierTypes.find(type => type.id === value);
        return supplierType ? supplierType.name : '';
      },
      getSupplierTypes: function() {
        this.$http.get('SupplierType')
          .then(response => {
            this.supplierTypes = response.body;
          }, error => {
            this.snackbar('Hubo un problema al obtener la lista de tipos de proveedores');
          })
      },
      goTo(url) {
        const self = this;
        self.$router.push('/' + url);
      },
      searchByParams: function() {
        const queryString = Object.keys(this.search).filter(key => this.search[key] !== '').map(key => key + '=' + this.search[key]).join('&');
        this.$http.get(`Suppliers/search?${queryString}`)
          .then(response => {
            const list = response.body;
            this.list = list;
            this.source = list;
            this.loading = false;
          }, error => {
            this.snackbar('Hubo un problema al obtener la lista');
            console.error(error);
          });
      },
      searchOnTable: function() {
        const self = this;
        this.list = _.filter(this.source, function(item) {
          return 1 === 2
        });
      },
      snackbar: function(message) {
        events.$emit('snackbar', message);            
      }
    },
    mounted() {
      this.getSupplierTypes();
      this.getList();
    },
    filters: {
      moment: function (date) {
        return moment(date).locale("es").format('LL');
      }
    },
    watch: {
      search: {
        deep: true,
        handler(value) {
          this.debouncedSearchFilter();
        },
        immediate: false
      }
    },
    created: function() {
      this.debouncedSearchFilter = _.debounce(this.searchByParams, 500);
    },
  }
</script>

<style scoped>
.pre-inherit {
  font: inherit;
}
.table-catalog {
  padding: 15px 30px 30px 30px;
}

.table-catalog >>> table.v-table thead th:not(:first-child):not(:last-child),
.table-catalog >>> table.v-table tbody td:not(:first-child):not(:last-child) {
  padding-left: 15px;
}

/*.table-catalog >>> table.v-table thead th:not(:nth-last-child(2)):not(:last-child),
.table-catalog >>> table.v-table tbody td:not(:nth-last-child(2)):not(:last-child) {
  padding-right: 15px;
} */

.table-catalog >>> table.v-table thead tr th {
  font-size: 14px;
  font-weight: bold;
}

.table-catalog >>> table.v-table tbody tr td {
  font-size: 12px;
}
</style>